import { createRoot } from "react-dom/client";
import { AppRoot } from "./AppRoot";

const el = document.getElementById("react-root");
if (el) {
  createRoot(el).render(<AppRoot />);
}
